import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { HistoryPage } from "./pages/HistoryPage";
import { LearnPage } from "./pages/LearnPage";
import { MethodsPage } from "./pages/MethodsPage";
import { OutcomesPage } from "./pages/OutcomesPage";
import { OverviewPage } from "./pages/OverviewPage";
import { PlanPage } from "./pages/PlanPage";
import { ProgressPage } from "./pages/ProgressPage";
import { ReaderPage } from "./pages/ReaderPage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { RolesPage } from "./pages/RolesPage";
import { SessionPage } from "./pages/SessionPage";
import { AiReviewPage } from "./pages/AiReviewPage";
import { CaseWorkbenchPage } from "./pages/CaseWorkbenchPage";
import { PanoramaPage } from "./pages/PanoramaPage";
import { ProjectDashboardPage } from "./pages/ProjectDashboardPage";
import { TextbookPage } from "./pages/TextbookPage";

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/learn/reader/:chapter" element={<ReaderPage />} />
        <Route path="/plan" element={<PlanPage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/methods" element={<MethodsPage />} />
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/outcomes" element={<OutcomesPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/textbook/:token" element={<TextbookPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/panorama" element={<PanoramaPage />} />
        <Route path="/cases" element={<CaseWorkbenchPage />} />
        <Route path="/projects" element={<ProjectDashboardPage />} />
        <Route path="/ai-review" element={<AiReviewPage />} />
      </Route>
      <Route path="/learn/session/:sessionId" element={<SessionPage />} />
      <Route path="*" element={<Navigate to="/overview" replace />} />
    </Routes>
  );
}
